import { Component, OnInit } from "@angular/core";
import { OrderService } from "../../../../app/main/order-management/order.service";
import { CommonService } from "../../../shared/common.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["../full.component.scss"],
})
export class AppHeaderComponent implements OnInit {
  userData;
  ntervalId: any;
  audio: any;
  interval: any;
  NewOrderCount: boolean = false;
  constructor(
    private commonService: CommonService,
    public orderService: OrderService
  ) {}

  ngOnInit() {
    this.userData = this.commonService.getUser();

    this.interval = setInterval(() => {
      const permissions = this.commonService.getStorage("_per");
      if (permissions["order"] == "W") {
        this.NewOrder();
      }
    }, 15000);
  }

  play() {
    var audio = new Audio(
      "https://s3.us-east-1.amazonaws.com/throneapp/throne/1629872945548_notification_sound.mp3"
    );
    audio.play();
  }
  NewOrder() {
    this.orderService.getNewOrder("").subscribe(
      (res) => {
        if (res["message"] == "Success") {
          this.NewOrderCount =
            res.data.response.isUnassignedSoundNeedsToBeNotified;
          localStorage.setItem(
            "new_or",
            res.data.response.isUnassignedSoundNeedsToBeNotified
          );
          if (this.NewOrderCount == true) {
            this.play();
          }
          // console.log('new order',this.NewOrderCount)
        } else {
        }
      },
      (err) => {}
    );
  }
  logoutUser() {
    this.commonService.logOut();
  }
}
